import type { EventFilter } from "@/Modules/Chat/WebSocketManager";
import type { ChatRoomItemMessageWebSocket } from "@/Modules/Chat/Models/WebSocket";
import { ChatRoomItemType } from "@/Modules/Chat/Models/Domain/Chat";

import { type ChatStore, useChatStore } from "@/Modules/Chat/Store";

import { hasValue, isObject } from "@/Utils/Objects";

export interface ExtraParamsUnknownChatRoomItem {
  chatStore: ChatStore;
}

export const isUnknownChatRoomItem = (message: unknown) => {
  return isObject(message) && hasValue(message.chat);
};

export const unknownChatRoomItemHandler = (
  message: ChatRoomItemMessageWebSocket,
  { chatStore = useChatStore() }: ExtraParamsUnknownChatRoomItem
): Promise<undefined> => {
  if (
    chatStore.rooms[message.chat] &&
    chatStore.rooms[message.chat].events !== undefined &&
    message.eid !== undefined
  ) {
    chatStore.rooms[message.chat].events.unshift({
      type: ChatRoomItemType.UNKNOWN,
      id: message.eid,
    });
  }

  return Promise.resolve(undefined);
};

export default {
  isType: isUnknownChatRoomItem,
  handler: unknownChatRoomItemHandler,
} as EventFilter<ExtraParamsUnknownChatRoomItem>;
